import { render } from "./UpdateBucket.vue?vue&type=template&id=675387bc&scoped=true"
import script from "./UpdateBucket.vue?vue&type=script&lang=js"
export * from "./UpdateBucket.vue?vue&type=script&lang=js"

import "./UpdateBucket.vue?vue&type=style&index=0&id=675387bc&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675387bc"]])

export default __exports__